import { useContext } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import { UPDATE_ALERT } from '@api/graphql/manualAlerts';
import { updateDashboardTitle } from '@store/tempDashboard/actions';
import { FormActionContext } from '../context';

const useUpdateAlert = (setSaving, alert, dispatch) => {
  const { actions: { onCancel } } = useContext(FormActionContext);
  const [createAlert] = useMutation(UPDATE_ALERT, {
    onCompleted(data) {
      const { updateManualAlert: { name } } = data;
      onCancel();
      dispatch(updateDashboardTitle(`Alert: ${alert.name}`, `Alert: ${name}`));
      setSaving(false);
      message.success(`Alert "${name}" updated successfully`);
    }
  });
  return createAlert;
};

export default useUpdateAlert;
